import { Button } from '@inflearn/ds-react-next';
import { useLang } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';
import { INFLEARN_URL } from '../../../../../../constants/urls';
import useInstructorProfileQuery from '../../../../../../hooks/useInstructorProfileQuery';
import useQueryParams from '../../../../../../hooks/useQueryParams';
import { eventNames } from '../../../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../../../utils/GTM/useTrackMixpanelEvent';

export function MentoringApplyButton() {
  const { t } = useTranslation();
  const { trackMixpanelEvent } = useTrackMixpanelEvent();
  const { id } = useQueryParams();
  const { data: instructorProfile } = useInstructorProfileQuery({
    userId: String(id),
    isInstructor: true,
  });
  const { isKo } = useLang();

  if (!instructorProfile || !instructorProfile.mentor) {
    return null;
  }

  const isActiveMentor = isKo && Boolean(instructorProfile.mentor?.isActive);

  if (!isActiveMentor) {
    return null;
  }

  return (
    <Button
      variant="default"
      size="sm"
      radius="md"
      component="a"
      aria-label={t('인프런 멘토링 상세 이동')}
      href={INFLEARN_URL.MENTORING(instructorProfile.mentor.id)}
      onClick={(event) => {
        event.preventDefault();
        trackMixpanelEvent(eventNames.CLICK_MENTORING_BUTTON);
        window.location.href = event.currentTarget.href;
      }}
    >
      {t('멘토링')}
    </Button>
  );
}
